import { Typography } from '@p2p/components';

import styles from './InfoBlockItem.module.scss';
import { InfoBlockItemProps } from './InfoBlockItem.types';

export const InfoBlockItem = ({ step, pathImg, title }: InfoBlockItemProps) => {
  return (
    <div className={styles.item}>
      <div className={styles.itemContainer}>
        <Typography variant="h1" color="orange">
          {step}
        </Typography>
        <Typography variant="text-m-bold" color="heading" className={styles.itemTitle}>
          {title}
        </Typography>
      </div>
      <img className={styles.itemImg} src={pathImg} alt="Info Block Image" />
    </div>
  );
};
